import {
  RANGE_MATCH_REGEX_DELIMITER,
  STRING_MATCHER_FUNCTION,
  STRING_MATCHER_RE_FUNCTION,
} from "components/reportsV3/types/constants";

/** Returns whether match text is empty after trimming. */
export function isBlankMatchText(text) {
  return (text ?? "").trim() === "";
}

/** Returns whether match text is a delimited regular expression. */
export function isRegexMatchText(text) {
  return (
    typeof text === "string" &&
    text.length >= 2 &&
    text.startsWith(RANGE_MATCH_REGEX_DELIMITER) &&
    text.endsWith(RANGE_MATCH_REGEX_DELIMITER)
  );
}

/** Returns the matcher `when` clause for a source column and match text. */
export function buildMatchWhen(sourceColumn, text) {
  const a = { func: "VAR", name: sourceColumn };
  if (isRegexMatchText(text)) {
    return {
      func: STRING_MATCHER_RE_FUNCTION,
      a,
      b: text.slice(
        RANGE_MATCH_REGEX_DELIMITER.length,
        text.length - RANGE_MATCH_REGEX_DELIMITER.length
      ),
    };
  }
  return { func: STRING_MATCHER_FUNCTION, a, b: text };
}

/** Returns whether a `when` clause is a string matcher. */
export function isMatchWhen(when) {
  return (
    when?.func === STRING_MATCHER_FUNCTION ||
    when?.func === STRING_MATCHER_RE_FUNCTION
  );
}

/** Returns the match text a matcher `when` clause was built from. */
export function matchWhenText(when) {
  if (when.func === STRING_MATCHER_RE_FUNCTION) {
    return `${RANGE_MATCH_REGEX_DELIMITER}${when.b}${RANGE_MATCH_REGEX_DELIMITER}`;
  }
  return when.b;
}

/** Returns the template with `{pattern}` replaced by the text. */
export function fillMatchTemplate(template, text) {
  return template.replace("{pattern}", () => text);
}
